var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdcLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8fdef4;}.cls-2{fill:#95e7ff;}.cls-3{fill:#7bbbcd;}.cls-4{fill:#4b6972;}.cls-5{fill:#6493a1;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo4_bel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.19,328.74l122,39.69,75.39,232.48-75.3,103.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M399.92,96,80,328.56v.14l122.18,39.73v-.08l0,.08L400,224.69l-.05-.05H400L400,96H400Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M400,96v0h-.1V224.64h.07l-.05.05L597.58,368.51l.06-.06v.06l122.2-39.76v-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M719.84,328.51,400,432.56v.08l-.07.06L597.61,705l.06-.06h.09L720,328.64h-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M400,432.59l-.07.05-.06-.05L202.19,704.91l.08.05v.09h395.4V705l.09-.05Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdcLogo);
export default __webpack_public_path__ + "static/media/adc_logo.dd628ab2295713dc6c39de6e1660eb4b.svg";
export { ForwardRef as ReactComponent };